import { injectable, inject } from 'inversify';
import {
  DataroomMultipartUploadAdapter, UploadDispatcher, DataroomMultipartUploadStrategy,
} from '@dealroadshow/file-uploader';
import dataroomUrlFactory from '@/dataroom/infrastructure/dataroomUrl';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { type IDataroomTenantContext, DataroomTenantContextSymbol } from '@dataroom/tenant/types';
import { validateDataroomTenant } from '@dataroom/tenant/validateDataroomTenant';
import Container from '@framework/di/Container';
import {
  SocketProcessingAdapter,
  type ISocketProcessingAdapterFactory,
} from '@/dataroom/app/DI/FileUpload/MultipartFileUploadDispatcher/SocketProcessingAdapter';

@injectable()
class MultipartFileUploadDispatcherFactory {
  constructor(
    @inject(Container) private readonly container: Container,
    @inject(SocketProcessingAdapter) private readonly processingAdapterFactory: ISocketProcessingAdapterFactory,
  ) {}

  create = (tenantCode: DataroomTenant | null = null) => {
    const tenant = (
      tenantCode ||
      this.container.get<IDataroomTenantContext>(DataroomTenantContextSymbol).tenant
    );

    validateDataroomTenant(tenant);

    const dataroomUrl = dataroomUrlFactory(tenant);

    const multipartUploadAdapter = new DataroomMultipartUploadAdapter({
      url: dataroomUrl.getUploadFileUrl(),
    });

    const processingAdapter = this.processingAdapterFactory(tenant);

    return new UploadDispatcher(
      new DataroomMultipartUploadStrategy(multipartUploadAdapter, processingAdapter),
    );
  };
}

export default MultipartFileUploadDispatcherFactory;
